import { useEffect, useRef, useState } from 'react';
import RolePicker from './RolePicker';
import { avatarGradient, monogram } from '../../utils/avatarColor';
import { relativeTime } from '../../utils/relativeTime';

export default function TeamMemberRow({ member, currentUid, onChangeRole, onRemove }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        if (!menuOpen) return undefined;
        const onDocClick = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
        };
        document.addEventListener('mousedown', onDocClick);
        return () => document.removeEventListener('mousedown', onDocClick);
    }, [menuOpen]);

    const isSelf = member.uid === currentUid;
    const grad = avatarGradient(member.uid);
    const displayName = member.name || member.uid;
    const last = relativeTime(member.lastSeenAt);

    return (
        <div className="team-row">
            <div
                className="team-avatar"
                aria-hidden="true"
                style={{ background: `linear-gradient(135deg, ${grad.from}, ${grad.to})` }}
            >
                {monogram(member.name, member.email)}
            </div>
            <div className="team-row-id">
                <div className="team-row-name">
                    {displayName}
                    {isSelf && <span className="team-row-you">You</span>}
                </div>
                <div className="team-row-email">{member.email || '—'}</div>
            </div>
            <RolePicker
                currentRole={member.role}
                onChange={(newRole) => onChangeRole(member.uid, newRole)}
            />
            <div className="team-row-meta" data-testid="member-last-active">{last}</div>
            <div className="team-row-actions" ref={menuRef}>
                <button
                    type="button"
                    className="kebab"
                    aria-label={`Member actions for ${displayName}`}
                    aria-haspopup="menu"
                    aria-expanded={menuOpen}
                    onClick={() => setMenuOpen((v) => !v)}
                >
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor">
                        <circle cx="3" cy="7" r="1.3" />
                        <circle cx="7" cy="7" r="1.3" />
                        <circle cx="11" cy="7" r="1.3" />
                    </svg>
                </button>
                {menuOpen && (
                    <ul className="kebab-menu" role="menu">
                        <li
                            role="menuitem"
                            className="kebab-menu-item kebab-menu-danger"
                            onClick={() => { setMenuOpen(false); onRemove(member.uid); }}
                        >
                            Remove from facility
                        </li>
                    </ul>
                )}
            </div>
        </div>
    );
}
